import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { signInAdmin } from '../services/adminAuthService';

const { FiArrowLeft, FiEye, FiEyeOff, FiLock, FiMail } = FiIcons;

function AdminLogin({ onAuthenticated }) {
  const [email, setEmail] = useState('admin@admin.com');
  const [password, setPassword] = useState('');
  const [visible, setVisible] = useState(false);
  const [status, setStatus] = useState({ loading: false, error: '' });

  const submit = async (event) => {
    event.preventDefault();
    setStatus({ loading: true, error: '' });

    try {
      await signInAdmin(email, password);
      onAuthenticated();
    } catch (error) {
      setStatus({
        loading: false,
        error: error.message || 'Unable to sign in.'
      });
    }
  };

  return (
    <main className="admin-login">
      <section className="admin-login-brand">
        <Link to="/">
          <SafeIcon icon={FiArrowLeft} /> Return to publication
        </Link>
        <div>
          <span className="admin-login-mark">OG</span>
          <p>OPINIGURU NEWSROOM</p>
          <h1>Journalism deserves a focused workspace.</h1>
          <p className="admin-login-summary">
            Manage sources, monitor publishing activity and keep the
            newsroom informed from one secure dashboard.
          </p>
        </div>
        <small>Independent reporting · Informed analysis</small>
      </section>

      <section className="admin-login-panel">
        <form className="admin-login-card" onSubmit={submit}>
          <span className="admin-overline">SECURE ACCESS</span>
          <h2>Welcome back</h2>
          <p>
            Sign in with your authorized Supabase newsroom account.
          </p>

          <label htmlFor="admin-email">Email address</label>
          <div className="admin-input">
            <SafeIcon icon={FiMail} />
            <input
              id="admin-email"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              autoComplete="email"
              required
            />
          </div>

          <label htmlFor="admin-password">Password</label>
          <div className="admin-input">
            <SafeIcon icon={FiLock} />
            <input
              id="admin-password"
              type={visible ? 'text' : 'password'}
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              autoComplete="current-password"
              required
            />
            <button
              type="button"
              onClick={() => setVisible(!visible)}
              aria-label={
                visible ? 'Hide password' : 'Show password'
              }
            >
              <SafeIcon icon={visible ? FiEyeOff : FiEye} />
            </button>
          </div>

          {status.error && (
            <p className="admin-login-error" role="alert">
              {status.error}
            </p>
          )}

          <button
            className="admin-login-submit"
            disabled={status.loading}
          >
            {status.loading ? 'Signing in…' : 'Sign in to newsroom'}
          </button>
          <small>
            Access is restricted to authorized editorial staff.
          </small>
        </form>
      </section>
    </main>
  );
}

export default AdminLogin;